import { AfterContentInit, Component, ElementRef, ViewChild } from '@angular/core';

@Component({
    selector: 'app-download-signature',
    templateUrl: './download-signature.component.html'
})

export class DownloadSignatureComponent implements AfterContentInit {
    @ViewChild('iframe') iframe: ElementRef;

    iframeSrc = "https://survey.typeform.com/to/QlBQFtv5";

    ngAfterContentInit(): void {
        setTimeout(() => {
            this.iframe.nativeElement.src = this.iframeSrc;
        }, 0);
    }
}
